"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var personalizationSubCategory_1 = require("./personalizationSubCategory");
var automaticProcessingSubCategory_1 = require("./automaticProcessingSubCategory");
var calendarCategory = {
    key: 'calendar',
    titleStringKey: 'optionCategory_Calendar',
    icon: "Calendar" /* Calendar */,
    subcategories: [personalizationSubCategory_1.default, automaticProcessingSubCategory_1.default],
};
exports.default = calendarCategory;
//# sourceMappingURL=category.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-options-calendar/lib/data/category.js
// module id = 5244
// module chunks = 2